

export type BinaryValues = '0' | '1';

export enum BINARY_VALUES {
    ZERO = '0',
    ONE = '1'
}